<script context="module">
  import {External as Ext} from "../external";
  import AiTextCompletionOptions from "./AiTextCompletionOptions.svelte";

  export function showAiTextCompletionOptions(target, options) {
    Ext.Tools.showHtmlTooltip(target, {
      width: 320,
      component: (tooltip, target) => {
        return new AiTextCompletionOptions({
          target: target,
          props: {
            ...options,
            onOptionSelected: () => {
              tooltip.refreshPosition();
            },
            onComplete: (selected, selectedOption) => {
              if (options.onComplete) {
                options.onComplete(selected, selectedOption);
              }

              if (tooltip) {
                tooltip.close();
                tooltip = null;
              }
            }
          }
        });
      }
    });
  }
</script>
<script>
  import {External, M} from "../external";

  export let phrase = External.Website.websiteTitle,
    elementType = 'paragraph',
    hasExtraBtn = false,
    extraBtnType = '',
    extraBtnText = '',
    decoratePhrase = (currentPhrase, selectedOption) => {
      return currentPhrase;
    };


  export let onComplete = () => {
  };

  export let onOptionSelected = () => {
  };

  let loading = false;
  let selectedOption = '';
  let topic = '', customPhrase = '';

  let getPrompt = () => {
    let prompt = selectedOption === 'GENERATE' ? customPhrase : phrase;
    let decoratedPrompt = decoratePhrase(prompt.trim(), selectedOption);
    if (decoratedPrompt) {
      return decoratedPrompt;
    }
    return prompt;
  };

  let submit = () => {
    if (loading) {
      return;
    }
    loading = true;
    External.Tools.makeAiTextSuggestion({
      topic: topic,
      prompt: getPrompt(),
      type: selectedOption,
      elementType: elementType,
      onComplete: (content) => {
        loading = false;
        onComplete(content.text, selectedOption);
      },
      onError: () => {
        loading = false;
      }
    });
  }

  let showToneChangePopup = (event) => {
    let options = [{
      text: M.TEXT_ASSIST_TONE_PROFESSIONAL,
      tag: 'professional',
      icon: 'material-icons-outlined',
      iconText: 'work'
    },{
      text: M.TEXT_ASSIST_TONE_FRIENDLY,
      tag: 'friendly',
      icon: 'material-icons-outlined',
      iconText: 'sentiment_satisfied'
    },{
      text: M.TEXT_ASSIST_TONE_RELAXED,
      tag: 'relaxed',
      icon: 'material-icons-outlined',
      iconText: 'mood'
    },{
      text: M.TEXT_ASSIST_TONE_PLAYFUL,
      tag: 'playful',
      icon: 'material-icons-outlined',
      iconText: 'sentiment_very_satisfied'
    },{
      text: M.TEXT_ASSIST_TONE_EXCITED,
      tag: 'excited',
      icon: 'material-icons-outlined',
      iconText: 'sentiment_very_satisfied'
    },{
      text: M.TEXT_ASSIST_TONE_ASSERTIVE,
      tag: 'assertive',
      icon: 'material-icons-outlined',
      iconText: 'handshake'
    }];
    External.Tools.showTooltipOptions(event.target, options, (clicked, idx, text, tag) => {
	  topic = tag;
	  optionSelected('CHANGE_TONE');
    });
  };

  let optionSelected = (option) => {
    if (loading) {
      return;
    }
    selectedOption = option;
    if (option !== 'GENERATE') {
      submit();
    }
    setTimeout(() => {
      onOptionSelected(selectedOption)
    }, 10);
  }
</script>

<div class="col20 f-left ai-buttons-wrapper">
  <div class="flex align-center mb-15 col20 f-left">
    <div class="f-left t-center mr-20">
      <svg class="fingerprint-icon" style="padding:15px;" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" x="0px" y="0px" width="24px" height="24px"
           viewBox="0 0 48 48">
        <path
          d="M19.25 42q-2.55 0-4.325-1.9-1.775-1.9-2.025-4.3-2.95-.25-4.925-2.475Q6 31.1 6 27.9q0-1.1.275-2.125T7.1 23.8q-.55-.9-.825-1.9Q6 20.9 6 19.75q0-3 2.075-5.15Q10.15 12.45 13 12.1q.1-2.55 1.925-4.325Q16.75 6 19.3 6q1.45 0 2.575.525Q23 7.05 24 8.05q1-1 2.1-1.525Q27.2 6 28.65 6q2.5 0 4.3 1.775 1.8 1.775 1.95 4.325 2.9.25 5 2.425T42 19.75q0 1.15-.3 2.175t-.85 1.925q.55 1 .85 2.1.3 1.1.3 2.15 0 3.2-1.975 5.325T35.1 35.8q-.25 2.4-2.05 4.3-1.8 1.9-4.3 1.9-1.5 0-2.6-.5T24 40q-1.05 1-2.15 1.5-1.1.5-2.6.5Zm6.25-30v24q0 1.25.975 2.125T28.8 39q1.3 0 2.25-1.15t1.05-2.35q-1.15-.4-2.15-1.075-1-.675-1.7-1.675-.4-.55-.3-1.125.1-.575.65-.975t1.125-.3q.575.1.975.65.65.9 1.6 1.375.95.475 2.1.475 1.9 0 3.25-1.3T39 28.1q0-.45-.1-.925-.1-.475-.2-.975-.9.65-1.975.975-1.075.325-2.225.325-.65 0-1.075-.425Q33 26.65 33 26q0-.65.425-1.075.425-.425 1.075-.425 1.9 0 3.2-1.4 1.3-1.4 1.3-3.35 0-1.9-1.4-3.25t-3.2-1.45q-.5 1.2-1.425 2.125T30.85 18.55q-.6.25-1.15-.025-.55-.275-.75-.875-.2-.6.05-1.175.25-.575.85-.775.9-.3 1.475-1.2.575-.9.575-2.05 0-1.45-.95-2.45Q30 9 28.7 9t-2.25.875q-.95.875-.95 2.125Zm-3 24V12q0-1.25-.925-2.125T19.3 9q-1.3 0-2.275 1-.975 1-.975 2.45 0 1.15.55 2.025t1.45 1.175q.6.2.875.775T19 17.55q-.25.6-.825.9-.575.3-1.175.05-1.2-.4-2.1-1.325-.9-.925-1.4-2.125-1.75.15-3.125 1.475Q9 17.85 9 19.75q0 1.95 1.3 3.35 1.3 1.4 3.2 1.4.65 0 1.075.425Q15 25.35 15 26q0 .65-.425 1.075-.425.425-1.075.425-1.15 0-2.225-.35Q10.2 26.8 9.3 26.2q-.15.4-.225.85-.075.45-.075.9 0 2.15 1.325 3.525t3.225 1.375q1.1 0 2.075-.5.975-.5 1.625-1.35.4-.5 1-.625t1.1.275q.5.4.625 1t-.275 1.1q-.7 1-1.675 1.675-.975.675-2.125 1.075.1 1.2 1.05 2.35.95 1.15 2.3 1.15 1.35 0 2.3-.875.95-.875.95-2.125ZM24 24Z"></path>
      </svg>
    </div>
    <h4 class="f-left t-left h4-bigger">{@html M.TEXT_ASSIST_HEAD}</h4>
  </div>

  {#if hasExtraBtn}
    <a class:loading={loading && selectedOption === extraBtnType} class="col20 f-left ta-center middle-button blue"
       on:click={() => optionSelected(extraBtnType)}>
      <i class="fa fa-circle-o-notch fa-spin"></i>
      {extraBtnText}
    </a>
  {/if}
  <div class="col20 f-left flex flex-row space-between">
    <a class:loading={loading && selectedOption === 'IMPROVE'} class:mt-5={hasExtraBtn}
       class="ta-center middle-button blue flex-1 mr-5"
       on:click={() => optionSelected('IMPROVE')}>
      <i class="fa fa-circle-o-notch fa-spin"></i>
      {M.TEXT_ASSIST_IMPROVE}
    </a>
    <a class:loading={loading && selectedOption === 'CHANGE_TONE'} class:mt-5={hasExtraBtn}
       class="ta-center middle-button blue flex-none"
       on:click={(e) => showToneChangePopup(e)} style="padding: 0 5px;">
      <i class="fa fa-circle-o-notch fa-spin platform-bg" style="left: 6px;"></i>
      <i class="fa fa-sliders" style="color: #fff;"></i>
    </a>
  </div>
  <div class="col20 f-left flex flex-row space-between">
    <a class:loading={loading && selectedOption === 'EXPAND'} class="ta-center middle-button blue mt-5 flex-1 mr-5"
       on:click={() => optionSelected('EXPAND')}>
      <i class="fa fa-circle-o-notch fa-spin"></i>
      {M.TEXT_ASSIST_EXPAND}
    </a>
    <a class:loading={loading && selectedOption === 'SHORTEN'} class="ta-center middle-button blue mt-5 flex-1"
       on:click={() => optionSelected('SHORTEN')}>
      <i class="fa fa-circle-o-notch fa-spin"></i>
      {M.TEXT_ASSIST_SHORTEN}
    </a>
  </div>
  <a class:loading={loading && selectedOption === 'GENERATE'} class="col20 f-left ta-center middle-button blue mt-5"
     on:click={() => optionSelected('GENERATE')}>
    <i class="fa fa-circle-o-notch fa-spin"></i>{M.TEXT_ASSIST_GENERATE}
  </a>

  {#if selectedOption === 'GENERATE'}
    <div class="col20 f-left">
	  <!--
      <div class="popup-input-wrapper mt-25">
        <div class="col20 info">
          <h5>What's your page about?</h5>
        </div>
        <input type="text" class="transition-background" bind:value={customTopic}/>
      </div>
	  -->
      <div class="popup-input-wrapper mt-25">
        <div class="col20 info">
          <h5>{M.TEXT_ASSIST_GENERATE_TITLE}</h5>
        </div>
        <textarea class="transition-background" bind:value={customPhrase}></textarea>
      </div>
      <a class:loading={loading && selectedOption === 'GENERATE'} on:click={submit} class="middle-button gray rounded-effect col20 t-center">
        <i class="fa fa-circle-o-notch fa-spin"></i>{M.SUBMIT}
      </a>
    </div>
  {/if}
  <div class="ai-disclaimer col20 f-left mt-15 t-center">
    {@html M.TEXT_ASSIST_DISCLAIMER}
  </div>
</div>
